import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { PointRecordList } from './components/PointRecordList';

const MemberPointManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="點數紀錄列表"
          breadcrumbs={[
            {
              name: '會員點數管理',
            },
            {
              name: '點數紀錄列表',
            },
          ]}
        />
        <PointRecordList />
      </Col>
    </Row>
  );
};

export default MemberPointManagement;
